// Printing from the browser must produce the same document as the Print button:
// intercept Ctrl/Cmd + P and submit the same print form.
// Registered at the very top of the file on purpose: code further down throws on
// some pages, and everything after it never runs.
document.addEventListener('keydown', function (e) {
    if (!(e.ctrlKey || e.metaKey) || e.altKey || (e.key || '').toLowerCase() !== 'p') {
        return;
    }

    // Look the form up on keypress: in the cart it is rendered by React after load.
    const form = document.getElementById('print-web-page') || document.getElementById('print-pdf');

    if (!form) {
        return;
    }

    e.preventDefault();

    // requestSubmit goes through the submit handler, so the button loader still runs
    // on the product page. Without it, submit the form directly.
    if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
    } else {
        form.submit();
    }
});

import $ from "jquery";
import jQuery from "jquery";
import filterForm from "./helpers/filter_from";
import customFilterForm from "./helpers/custom_filter_form";

import {forEach} from './helpers/forEach';
import {Tooltip} from './tooltip';
import {Folders} from './folders';
import passwordToggle from "./helpers/password-toggle";

import analyticsService from "./helpers/analytics.service";
/****************************
 *
 * Lity video pop-up
 *
 ***************************/
import lity from "lity/dist/lity";
import {loadPrice} from "./helpers/loadPrice";
import {loadDeliveryStatuses} from "./helpers/deliveryStatus";

require('./jquery-ui/jquery-ui.min.js');

let _ = require('lodash');

/**
 * export for others scripts to use
 */
window.$ = $;
window.jQuery = jQuery;

/**
 * set CSRF token for every AJAX
 */

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

(function ContentLoader() {
    function wrap(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

    function insertContent(element, content) {
        element.innerHTML = content;
    }

    function elementSetHeight(element, force = null) {
        if (force != null) {
            element.style.height = force + 'px';
        } else {
            element.style.height = element.offsetHeight + 'px';
        }
    }

    let loaders = document.querySelectorAll('[data-loading-content]');
    forEach(loaders, function (loader) {
        let wrapper = document.createElement('div');
        wrap(loader, wrapper);
        // wrapper.style.transition = 'height 0.5s ease';
        // elementSetHeight(wrapper);
        $.ajax(loader.dataset.loadingContent, {
            method: 'GET',
        }).done(function (res) {
            insertContent(loader, res);
            // elementSetHeight(wrapper, loader.offsetHeight);
        });
    });
})();

(function DataCutter() {
    let togglers = document.querySelectorAll('.js-toggle-wall');
    forEach(togglers, function (toggler) {
        let $open = toggler.querySelector('.walltext__open');
        if ($open) {
            toggler.querySelector('.walltext__open').onclick = function () {
                toggler.classList.add('is-open');
            };
        }
        let $close = toggler.querySelector('.walltext__close');
        if ($close) {
            $close.onclick = function () {
                toggler.classList.remove('is-open');
            }
        }
    });
})();

/** ----------------------------------------
 Faq
 ---------------------------------------- */
require('./helpers/faq')

/** ----------------------------------------
 Top Link
 ---------------------------------------- */

require('./helpers/top_link')

/** ----------------------------------------
 Google maps
 ---------------------------------------- */
if ($('#maps-contact').length) {
    require('./helpers/maps/maps-loader');
}

/** ----------------------------------------
 Formvalidation
 ---------------------------------------- */
require('./helpers/form_validation');


/** ----------------------------------------
 Swiper sliders
 ---------------------------------------- */
require('./helpers/swipersliders');


/** ----------------------------------------
 Mobile menu
 ---------------------------------------- */
require('./helpers/mmenu');


/** ----------------------------------------
 Navigation
 ---------------------------------------- */
require('./helpers/navigation');

const tooltips = () => {
  let order_tooltips = document.querySelectorAll('[data-ordertooltip]');
  if (order_tooltips.length) {
    forEach(order_tooltips, function (tooltip) {
      new Tooltip(tooltip, {
        content: `<div><b>${window.SiteSettings.order_info_tooltip}</b></div>`,
      });
    });
  }
};

function updateSelectedClass(select) {
    if (select.options[select.selectedIndex].disabled) {
        $(select).addClass('placeholder-selected');
    } else {
        $(select).removeClass('placeholder-selected')
    }
}

$(function () {
    filterForm($("form.filters"));

    const lazyFilterSearch = $(".lazy-filter-search");
    if (lazyFilterSearch.length) {
        customFilterForm(lazyFilterSearch);
    }

    const lazyLoadingTable = $('.lazy-loading-table');
    if (lazyLoadingTable.length) {
        const tableResult = $('#ajax-table-default-results');
        tableResult.data('lazy-load', '400');
        tableResult.data('spinner', 'spinner-lazy-loading');
        customFilterForm(lazyLoadingTable, tableResult, () => {}, null, true);
    }

    tooltips();
    loadDeliveryStatuses();
    passwordToggle();

    const selects = $('.input-section--select select');
    selects.on('change', function () {
        updateSelectedClass(this)
    });

    //set the top-link
    $('#top-link').topLink({
        min: 200,
        fadeSpeed: 500,
        scrollSpeed: 500
    });

    $('.font-sizer').each(function () {
        let _this = $(this);
        let _type = _this.find('.type');
        _this.find('.font-size').html('font-size = ' + _type.css('font-size'));
        _this.find('.line-height').html('line-height = ' + _type.css('line-height'));
        _this.find('.font-family').html('font-family = ' + _type.css('font-family'));
    });

    /**
     * force click even on change input for
     * correct class handling with
     * jqueryvalidation
     */

    $('select').on('input change', function () {
        $(this).trigger('click')
    });

    require('colcade');

    $('.grid').colcade({
        columns: '.grid-col',
        items: '.grid-item'
    });

    /**
     * Open and close div on click
     * div with same toggle_id
     */

    const $toggletime = 200;

    function toggleCombo(id) {
        const toggleButton = $(`[data-toggle='${id}']`);
        if (!toggleButton.hasClass('is-animate')) {
            $(`[data-toggle_id='${id}']`).slideToggle($toggletime);
            toggleButton.toggleClass('hover open').addClass('is-animate');
            setTimeout(function () {
                toggleButton.removeClass('is-animate');
            }, $toggletime)
        }
    }

    const list = ['specificaties', 'asd'];

    function toggleScrollTo(id) {
        if ($.inArray(id, list) !== -1) {
            $('html, body').animate({
                scrollTop: $(`[data-toggle_id='${id}']`).offset().top - $('nav').height()
            }, 500);
        }
    }

    $('[data-toggle-close]').on('click', function () {
        toggleCombo($(this).closest('[data-toggle_id]').data('toggle_id'));
        return false;
    });

    $('.js-video-first-clip').on('click', function () {
        const PLAYER_TYPE_YOUTUBE = 'youtube';
        const PLAYER_TYPE_VIMEO = 'vimeo';
        const videoClip = $(this);
        const videoUrl = videoClip.data('video-url');
        const videoContainer = videoClip.closest('.video-embed-optimized').find('.js-video-container');
        videoClip.css('display', 'none');
        videoContainer.css('display', 'block');
        const typePlayer = videoClip.data('type-player');
        if(typePlayer === PLAYER_TYPE_YOUTUBE) {
            const videoUrlFull = `${videoUrl}?autoplay=1`;
            videoContainer.html(`<iframe class="embed-responsive-item" allow="autoplay; encrypted-media" src="${videoUrlFull}" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`);
        } else if (typePlayer === PLAYER_TYPE_VIMEO) {
            const videoUrlFull = `${videoUrl}?h=c55df8a74e&autoplay=1&loop=1&title=0&byline=0&portrait=0`;
            videoContainer.html(`<iframe src="${videoUrlFull}" style="width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`);
        }
        return false;
    });

    $('[data-toggle]').on('click', function () {
        const id = $(this).data('toggle');
        toggleCombo(id);
        if ($(this).hasClass('open')) {
            toggleScrollTo(id);
        }

        return false;
    });

    $("[data-animate-to]").on('click', function (e) {
        const source = e.currentTarget.dataset.animateTo;
        const target = document.getElementById(source);

        if (target) {
            e.preventDefault();
            $("html, body").animate({scrollTop: ($(target).offset().top - 130)}, 500);
        }
    });

    $('.custom-select').on('change', function () {
        const $this = $(this);
        if ($this.data('prevdata')) {
            toggleCombo($this.data('prevdata'));
        }
        $this.data('prevdata', $this.val());
        const id = $this.val();
        toggleCombo(id);

        const selected = $this.find(':selected')[0];

        if (selected) {
            const $productGroup = $(`[data-toggle_id='${id}']`).find('[data-gaactive]');
            if ($productGroup.length) {
                const trackingData = $productGroup.data('gadata');
                analyticsService.trackImpression(trackingData.items);
            }

            const url = $(selected).data('toggle_url');

            if (url != 'undefined') {
                window.history.replaceState({}, document.head.title, url);
            }
        }
    });

    $('.product-detail-table .custom-select').trigger('change');

    const deliveryDateInput = $('form[name=place-order]').find('[name=delivery-date]');

    deliveryDateInput.datepicker({
        dateFormat: 'dd-mm-yy',
        minDate: 3,
        beforeShowDay: function (date) {
            const day = date.getDay();
            return [day !== 0 && day !== 6, '', 'Levering alleen op werkdagen'];
        }
    });

    $('.btn-datepicker').on('click', function () {
        deliveryDateInput.datepicker('show');
    });

    $('input.filter-document').on('change', function (e) {

        const target = $(e.target);

        // Toggle target butten state
        const btn = target.parent('.btn');
        btn.toggleClass('btn-primary');
        btn.toggleClass('btn-dark');

        // Toggle other button state
        if (target.val() === 'alle') {
            const others = $('input.filter-document[value!=alle]');

            if (target.prop('checked')) {
                others.prop('checked', false);

                const othersBtn = others.parent();
                othersBtn.removeClass('btn-dark');
                othersBtn.addClass('btn-primary');
            }

        } else {
            const all = $('input.filter-document[value=alle]');
            all.prop('checked', false);

            const allBtn = all.parent('.btn');
            allBtn.removeClass('btn-dark');
            allBtn.addClass('btn-primary');
        }

        $('form#search').submit();

    });

    $('a.filter-reset').on('click', function (e) {
        e.preventDefault();

        const filters = $('input.filter-document[value!=alle]');
        filters.prop('checked', false);

        const filtersBtn = filters.parent();
        filtersBtn.removeClass('btn-dark');
        filtersBtn.addClass('btn-primary');

        const all = $('input.filter-document[value=alle]');
        all.prop('checked', true);

        const allBtn = all.parent();
        allBtn.removeClass('btn-primary');
        allBtn.addClass('btn-dark');

        $('form#search').submit();
    });

    $('.filter-search').on('change', function () {
        $(this).closest('form').submit();
    });

    // Only display the logout button for AribaUsers when the session is not inside an iframe
    if (window.location === window.parent.location) {
        $('.hidden-iframe').css('display', 'block');
    }

    const cancelOciOrder = document.getElementById('cancel-oci-order');
    if (cancelOciOrder) {
        cancelOciOrder.submit();
    }
});

new Folders(
    document.getElementById('master-folder'),
    document.getElementById('master-files')
);

let loginPopup = $('.login-popup');

$(function () {
    loginPopup.addClass('init');
});

const activeLoginTrigger = function () {
  $('.login-popup-trigger').on('click', function (e) {
    e.preventDefault();
    loginPopup.addClass('is-active');
    $('body').addClass('is-locked');
  });
};

activeLoginTrigger();

$('.login-popup__underlay').on('click', function () {
    loginPopup.removeClass('is-active');
    $('body').removeClass('is-locked');
});

$('a.opener').on('click', function (e) {
    e.preventDefault();

    const link = e.target.href;
    const windowsProperties = $(e.target).data('linkProperties');
    const size = windowsProperties.split(',');

    let props = 'width='.concat(size[0]).concat(',height=').concat(size[1]);

    window.open(link, 'Deel deze pagina', props);
});

let currentOpen = 'normal';
let animate = false;
$('[data-menu-id]').on('click', function () {

    let id = this.dataset.menuId;
    if (currentOpen === id || animate) {
        return false;
    }
    $('[data-menu-id]').removeClass('active');

    currentOpen = id;
    animate = true;
    $('.product-menu__holder').slideUp(300);
    $(this).addClass('active');
    $(this).addClass('animate');
    setTimeout(function () {
        $('#' + id).slideDown(300);
        $('[data-menu-id]').removeClass('animate');
        setTimeout(function () {
            animate = false;


        }, 300)
    }, 300);
});



// Update product group id
let printForm = document.getElementById('print-pdf');

if (printForm) {
    $('.custom-select').on('change', function () {
        const $this = $(this);
        let selected = $this.val();
        let productGroupId = $('input[name="productGroupId"]');

        if (productGroupId.length) {
            productGroupId.val(selected);
        }
    });
}

// Update product group id
let printWebPageForm = document.getElementById('print-web-page');

if (printWebPageForm) {
    $('.custom-select').on('change', function () {
        const $this = $(this);
        let selected = $this.val();
        let productGroupId = $('input[name="productGroupId"]');

        if (productGroupId.length) {
            productGroupId.val(selected);
        }
    });

    printWebPageForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const form = this;
        const submitButton = this.querySelector('button[type="submit"]');
        const originalButtonContent = submitButton.innerHTML;

        showButtonLoader(submitButton);
        submitButton.disabled = true;
        form.submit();

        setTimeout(function () {
            hideButtonLoader(submitButton, originalButtonContent);
            submitButton.disabled = false;
        }, 3000);
    });
}

function showButtonLoader(button) {

    let printWebPageForm = document.getElementById('print-web-page-append-loader');

    if (printWebPageForm) {
        button.innerHTML = printWebPageForm.innerHTML;
    } else {
        button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Loading...';
    }

    button.classList.add('btn-print-loading');
}

function hideButtonLoader(button, originalContent) {
    button.innerHTML = originalContent;
    button.classList.remove('btn-print-loading');
}

//agenda
$('input.filter-agenda').on('change', function (e) {

    const target = $(e.target);

    // Toggle target butten state
    const btn = target.parent('.btn');
    // btn.toggleClass('btn-primary');
    btn.toggleClass('filter-btn--active');

    $('form#search').submit();
});

let video = $('.video-player');

if (video) {
    $(video).on("click", function () {
        let child = $(this).find('.player-wrapper-video');
        let iframe_src = $(child).data('src');
        $(child).html(lity(iframe_src));
    });
}

let hover = document.getElementsByClassName('menu-hover');
let close = document.getElementsByClassName('product-menu-close');

if (close.length && hover.length) {
    $(hover).on({
        mouseenter: function () {
            $(hover).removeClass('hidden');
        },
    });

    $(close).on('click', function () {
        $(hover).addClass('hidden');
    });
}

const loadPrices = function (priceRequests, urlPrice = null, attrDataName) {
  const cb = () => {
    priceRequests = [];
    tooltips();
      loadDeliveryStatuses();
  };
  $("[data-price]").each(function (key, element) {
      const priceValue = $(element).attr('data-price');
      if (!priceValue) {
          priceRequests.push({
              value: loadPrice(element, cb, urlPrice, attrDataName)
          });
      }
  });
};

let priceRequests = [];

export function initPrice(selectorSection, nameUrlDataAtr, attrDataName) {
    const initialSection = $(selectorSection);
    if (initialSection.length > 0) {
        if (priceRequests.length > 0) {
            _.forEach(priceRequests, function (priceRequest, key) {
                priceRequest.value.abort();
            });

            priceRequests = [];
        }
        loadPrices(priceRequests, initialSection.data(nameUrlDataAtr), attrDataName);
    }
}

initPrice('[data-initial-order-get-total-price]', 'ajax-total-price-url', 'data-shopping-cart-id');




const scrollToForms = document.querySelectorAll('[data-scroll-to-form]');
if (scrollToForms.length) {
    for (let i = 0; i < scrollToForms.length; i++) {
        const triggerBtn = scrollToForms[i];
        const formContainer = document.getElementById('job-opportunity-form-container');

        triggerBtn.addEventListener('click', function (e) {
            e.preventDefault();

            if (formContainer) {
                const yOffset = -275;
                const y = formContainer.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
        })
    }
}

$(document).ready(function () {
    document.querySelectorAll('.switcher-label').forEach(function (label) {
        label.addEventListener('click', function () {
            const radioInput = this.querySelector('input[type="radio"]');

            if (!radioInput.checked) {
                document.querySelectorAll('.switcher-label').forEach(function (lbl) {
                    lbl.classList.remove('selected');
                });

                this.classList.add('selected');

                radioInput.checked = true;

                this.closest('form').submit();
            }
        });
    });
});


$(document).ready(function () {
    analyticsService.trackAll();
});
